module.exports = __webpack_public_path__ + "img/niger.6e160500.svg";